<template>
	<div class="logo-selector freeMedias clearfix">
		<fieldset>
			<legend>Logo Annonceur</legend>
		</fieldset>
		<p>
			<em>Formats acceptés : .jpg ou .png - Taille maximum: 2 Mo</em>
		</p>
		<div class="media" v-if="logoMedia">
			<x-icon size="1.5x" class="custom-class" @click="removeLogo"></x-icon>
			<img
				:src="logoMedia.thumbnail"
				:width="logoMedia.width"
				:height="logoMedia.height"
			/>
		</div>
		<FilePond
			name="filepond-logo"
			ref="pond_logo"
			v-show="!parseInt(classified.logo)"
			acceptedFileTypes="image/jpeg, image/png"
			maxFileSize="2MB"
			imageValidateSizeMaxWidth="4000"
			imageValidateSizeMaxHeight="2000"
			labelIdle="<span class='filepond--label-action'></span>"
			labelMaxFileSizeExceeded="Le fichier est trop lourd"
			labelFileProcessing="Upload en cours"
			labelFileProcessingComplete="Upload terminé"
			@addfile="handleFileAddedLogo"
			@processfile="handleProcessFileLogo"
			@init="handleFilePondInitLogo"
		/>
	</div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import axios from "axios";
import vueFilePond, { setOptions } from "vue-filepond";
import FilePondPluginImageValidateSize from "filepond-plugin-image-validate-size";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import { XIcon } from "vue-feather-icons";
import Media from "./Media.vue";

// import "filepond/dist/filepond.min.css";

export default {
	name: "medias-selector",
	components: {
		FilePond: vueFilePond(
			FilePondPluginImageValidateSize,
			FilePondPluginFileValidateSize,
			FilePondPluginFileValidateType
		),
		XIcon,
	},
	mounted() {},
	created() {
		const self = this;
	},
	computed: {
		...mapState(["classified", "logoMedia", "is_admin"]),
	},
	methods: {
		handleProcessFileLogo: function (e, file) {
			setTimeout(() => {
				this.$refs.pond_logo.removeFile(file.id);
			}, 500);
			// this.$store.commit("setLogo", parseInt(file.serverId));
		},
		handleFileAddedLogo: function (e) {
			this.$refs.pond_logo.getFiles().forEach((file) => {
				/*
        INIT: 1,
        IDLE: 2,
        PROCESSING_QUEUED: 9,
        PROCESSING: 3,
        PROCESSING_COMPLETE: 5,
        PROCESSING_ERROR: 6,
        PROCESSING_REVERT_ERROR: 10,
        LOADING: 7,
        LOAD_ERROR: 8
        */
				switch (file.status) {
					case 2:
						this.$refs.pond_logo.processFile(file.id).then((file) => {
							// this.$refs.pond_logo.removeFile(file.id);
						});
						break;
				}
			});
		},
		handleFilePondInitLogo: function () {
			this.$refs.pond_logo.server = {
				process: (
					fieldName,
					file,
					metadata,
					load,
					error,
					progress,
					abort,
					transfer,
					options
				) => {
					const formData = new FormData();
					formData.append("uniq_id", this.classified.uniq_id);
					formData.append(fieldName, file, file.name);
					let config = {
						headers: {
							"Content-Type": "multipart/form-data",
						},
					};
					this.$store.commit("startXhr");
					axios
						.post(
							this.config.app.gateway +
								"?action=classified_v2_save_classified_logo",
							formData,
							config
						)
						.then((response) => {
							this.$store.commit("setLogo", response.data);
							load(response.data.attachment_id);
						})
						.catch((response) => {
							error(response);
						})
						.finally(() => this.$store.commit("endXhr"));

					return {
						abort: function () {
							abort();
						},
					};
				},
			};
		},
		removeLogo() {
			this.$store.commit("removeLogo");
		},
	},
};
</script>
<style lang="scss">
.media {
	display: inline-block;
	margin: 3px;
}
.filepond--list-scroller {
	transform: translate3d(0px, 128px, 0px);
}
.filepond--item {
	width: 100%;
}
.filepond--wrapper {
	display: inline-block;
	margin: 3px 3px 0 0;
}
.filepond--drop-label {
	position: relative;
	label {
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		position: absolute;
	}
}

.filepond--label-action {
	margin: -10px 0 0 -10px;
	background: url(../assets/upload.png) 50% 50% no-repeat;
	display: block;
	width: 10rem;
	height: 100rem;
	position: relative;

	&:after {
		content: " ";
		top: 150px;
		position: absolute;
		left: 0;
		right: 0;
		text-align: center;
		color: #d22e26;
	}
}
.logo-selector.freeMedias .filepond--label-action {
	&:after {
		content: " ";
	}
}
.filepond--file .filepond--file-status {
	align-items: flex-start;
	transform: none;
	width: 100%;
	padding-right: 2em;
	margin: 0;
	text-align: left;
	align-items: flex-start;
	* {
		white-space: normal;
	}
}
.filepond--file .filepond--file-info {
	display: none;
}
.filepond--file-status .filepond--file-status-sub {
	opacity: 0 !important;
}
.filepond--credits {
	display: none !important;
}
</style>
